export default {
  cancel: "cancel",
  date: "Created Date",
  description: "Description",
  dueDate: "Due Date",
  location: "location",
  multipleBarsChart: "Current Project Spending",
  name: "Name",
  orderId: "Order Id",
  partialCost: "Unit Cost",
  projectProfile: "Project Profile",
  quanty: "Quantity",
  save: "save",
  subtotal: "Subtotal",
  subtype: "Subtype",
  totalCost: "Total Cost",
  type: "Type",
  whoReceive: "Who Receive?",
  whoSent: "Who Sent?",
  newItem: "New Item",
  editItem: "Edit Item",
  structures: "Structures",
  personal: "Personal",
  surfaces: "Surfaces",
  pipes: "Pipes",
  disassembly: "Disassembly",
  manufacturing: "Manufacturing",
  assembly: "Assembly",
  replacement: "Replacement"
};
